import React from 'react';
import '../PrivacyPolicy/PrivacyPolicy.css';
import Footer from '../../compos/Footer/Footer';
import Header from '../../compos/Header/Header';

// Public Child Safety Standards page — linked from the Google Play Console
// "Child safety standards" declaration (required for Social apps).
const ChildSafety = () => {
	return (
		<div className='privacy-scroll-point d-flex flex-column justify-content-between'>
			<Header />
			<section className='text-start m-5'>
				<div className='privacy-text'>
					<h1>Child Safety Standards</h1>
					<p>Last updated: October 11, 2026</p>
					<p>
						BReporter has zero tolerance for child sexual abuse and exploitation (CSAE), including child sexual abuse
						material (CSAM). This page sets out our published standards against CSAE, which apply to every user and to
						all content shared on the BReporter app (Android and iOS) and website (b-reporter.com).
					</p>

					<h2>1. Prohibited Content and Behaviour</h2>
					<p>The following are strictly prohibited on BReporter:</p>
					<ul className='custom-list'>
						<li>Any child sexual abuse material (CSAM), whether real, drawn, edited or AI-generated.</li>
						<li>Content that sexualises minors in any way, including suggestive images, text, comments or captions.</li>
						<li>Grooming, i.e. building a relationship with a minor for the purpose of sexual abuse or exploitation.</li>
						<li>Sextortion, or soliciting sexual images or contact from minors.</li>
						<li>Trafficking of minors, or promoting, advertising or facilitating the exploitation of children.</li>
						<li>Sharing links to, or instructions for finding, any such material elsewhere.</li>
					</ul>

					<h2>2. Age Requirement</h2>
					<p>
						BReporter is not directed at children. Users must be at least 13 years old (or the minimum age required in
						their country) to create an account. We do not knowingly collect personal data from children under 13.
					</p>

					<h2>3. How to Report</h2>
					<p>If you see any content or behaviour on BReporter that may involve the abuse or exploitation of a child:</p>
					<ul className='custom-list'>
						<li>
							Email our Child Safety contact at{' '}
							<a href='mailto:breporter.services@gmail.com?subject=Child%20Safety%20Report'>
								breporter.services@gmail.com
							</a>{' '}
							with the subject "Child Safety Report", including a link to or description of the post, report, comment
							or account.
						</li>
						<li>
							Or use our <a href='/contact'>Contact Us</a> page, available from the app and the website.
						</li>
					</ul>
					<p>
						Please do not download, screenshot, or forward suspected CSAM, even to report it. A link or description is
						enough for us to act.
					</p>

					<h2>4. How We Respond</h2>
					<ul className='custom-list'>
						<li>Reports of CSAE are prioritised and reviewed as quickly as possible.</li>
						<li>Content that violates these standards is removed from the platform.</li>
						<li>Accounts involved in CSAE are permanently banned.</li>
						<li>
							We report confirmed CSAM and child exploitation to the relevant authorities, including the National Center
							for Missing &amp; Exploited Children (NCMEC) and Indian law enforcement via the National Cybercrime
							Reporting Portal (cybercrime.gov.in), and we preserve relevant data as required by law.
						</li>
						<li>We cooperate fully with law enforcement investigations.</li>
					</ul>

					<h2>5. Legal Compliance</h2>
					<p>
						BReporter complies with applicable child safety laws, including the Protection of Children from Sexual
						Offences (POCSO) Act, 2012, the Information Technology Act, 2000 and the IT (Intermediary Guidelines and
						Digital Media Ethics Code) Rules, 2021 in India, as well as the laws of other countries where the app is
						available.
					</p>

					<h2>6. Child Safety Point of Contact</h2>
					<p>
						Our designated point of contact for child safety matters, including enquiries from Google Play, app stores
						and law enforcement, can be reached at:
					</p>
					<ul className='custom-list'>
						<li>
							Email: <a href='mailto:breporter.services@gmail.com'>breporter.services@gmail.com</a>
						</li>
					</ul>

					<h2>7. Getting Help</h2>
					<p>
						If a child is in immediate danger, contact local emergency services first. In India, call the Childline
						helpline at 1098 or the emergency number 112. Elsewhere, you can report to NCMEC's CyberTipline at{' '}
						<a href='https://report.cybertip.org' target='_blank' rel='noreferrer'>
							report.cybertip.org
						</a>
						.
					</p>
				</div>
			</section>
			<Footer />
		</div>
	);
};

export default ChildSafety;
